import { render, staticRenderFns } from "./VTemplateCoverLetter.vue?vue&type=template&id=2a49087c&lang=pug&v-cloak=true"
import script from "./VTemplateCoverLetter.vue?vue&type=script&lang=ts"
export * from "./VTemplateCoverLetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RTemplateCoverLetter.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FCoverLetter%2FVTemplateCoverLetter.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports